import {
  shape,
  objectOf,
  string,
  number,
  oneOf,
  arrayOf,
  oneOfType,
} from 'prop-types';
import {
  Metric as MetricEnum,
  Precision as PrecisionEnum,
  Compare as CompareEnum,
  Timespan as TimespanEnum,
  Sort as SortEnum,
} from './constants';
import { values } from 'ramda';

export const City = shape({
  id: string,
  name: string,
  lat: number,
  long: number,
});

export const Cities = arrayOf(City);

export const ChartLegendData = arrayOf(shape({ name: string, color: string }));

export const CrimeData = shape({
  timespan: string,
  population: number,
  crimes: number,
  rate: number,
});

export const CrimeDataBatch = objectOf(arrayOf(CrimeData));

export const Metric = oneOf(values(MetricEnum));
export const Precision = oneOf(values(PrecisionEnum));
export const Compare = oneOf(values(CompareEnum));
export const Timespan = oneOf(values(TimespanEnum));
export const Sort = oneOf(values(SortEnum));

export const Options = shape({
  metric: Metric.isRequired,
  precision: Precision.isRequired,
  timespan: Timespan.isRequired,
  compare: Compare.isRequired,
  customTimespanInterval: string,
  customCompareInterval: string,
});

export const HoveredDate = oneOfType([string, number]);

export const BrowserLocation = shape({ search: string });

export const LongLat = shape({
  long: number,
  lat: number,
});

export const GeoBounds = shape({
  topLeft: LongLat,
  bottomRight: LongLat,
});

export const SpecText = arrayOf(
  shape({ style: string.isRequired, text: string.isRequired }),
);



// WEBPACK FOOTER //
// ./src/models.js